<artemis-breadcrumbs [breadcrumbs]="breadcrumbs"></artemis-breadcrumbs>
<artemis-customer-overview-card></artemis-customer-overview-card>
<div class="edit-crp-card" #detailForm>
  <artemis-loading-spinner *ngIf="(loading$ | async) || formLoading"></artemis-loading-spinner>
  <div ubi-curve-header class="edit-crp-card__header">
    <span class="edit-crp-card__header-text"> {{ 'crp.edit.header' | translate }} </span>
  </div>
  <div class="edit-crp-card__content-container">
    <div class="edit-crp-card__subsection">
      <artemis-details-form [isPrimary]="false" [customerCrpData]="crpData" (formDataChanged)="formChange($event)" (loading)="formLoadingHandler($event)">
      </artemis-details-form>
      <div class="edit-crp-card__btns-container">
        <div class="edit-crp-card__msg-container">
          <div class="edit-crp-card__hint-msg">
            <div *ngIf="hasFormerOrAliasName()"> {{ 'customer_info.message.alias_or_former_name_credit_consumption' | translate }} </div>
          </div>
          <div class="edit-crp-card__error-msg" [hidden]="!triedSubmit">
            <div [hidden]="isFormValid()"> {{ 'crp.edit.message.please_make_sure_you' | translate }} </div>
          </div>
        </div>
        <button class="btn btn_rounded edit-crp-card__submit-btn" mat-button ubi-round-button
                *ngIf="crpData?.record" [disabled]="loading || !isFormValid() || !isFormDirty()" (click)="updateCustomer()">
          {{ 'crp.edit.button.update' | translate }}
        </button>
        <button class="btn btn_accent-gradient-rounded edit-crp-card__submit-btn" mat-button ubi-round-button
                *ngIf="crpData?.record" [disabled]="loading" (click)="updateCustomer('crp')">
          {{ 'crp.edit.button.update_and_add_another_crp' | translate }}
        </button>
        <button class="btn btn_accent-gradient-rounded edit-crp-card__submit-btn" mat-button ubi-round-button
                *ngIf="crpData?.record" [disabled]="loading" (click)="updateCustomer('ra')">
          {{ 'crp.edit.button.complete' | translate }}
        </button>
      </div>
    </div>
    <div class="edit-crp-card__subsection crp-roles">
      <artemis-crp-role [crpId]="currentCrp?.id" (change)="onRoleChange($event)"></artemis-crp-role>
    </div>
    <div class="edit-crp-card__subsection" *ngIf="otherData">
      <div class="edit-crp-card__subsection-title">
        {{ 'crp.edit.title' | translate }}
      </div>
      <artemis-customer-other-data [rawOtherData]="otherData" [editMode]="true"></artemis-customer-other-data>
    </div>
  </div>
</div>
<div #customerDocument>
  <artemis-customer-document [record]="crpData?.record" (uploaded)="getCurrenCRP()" ></artemis-customer-document>
</div>
<artemis-crp-list-card></artemis-crp-list-card>
